import { render, staticRenderFns } from "./SelectOrDeselect.vue?vue&type=template&id=a64fbe5a&"
import script from "./SelectOrDeselect.vue?vue&type=script&lang=js&"
export * from "./SelectOrDeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports